import { render, staticRenderFns } from "./feedback-panel.vue?vue&type=template&id=96288ede&scoped=true"
import script from "./feedback-panel.vue?vue&type=script&lang=js"
export * from "./feedback-panel.vue?vue&type=script&lang=js"
import style0 from "./feedback-panel.vue?vue&type=style&index=0&id=96288ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96288ede",
  null
  
)

export default component.exports